const lang = {
  title_page: process.env.MIX_APP_NAME,
  title: 'パスワード再設定申込み完了',
  content: 'パスワードの再設定が完了しました。<br/>ログイン画面からログインしてください。',
  button: 'ログイン画面',
}

export default lang
